var URLSearchParams = require('url-search-params');
module.exports = {
    getQueryStringValue: function (key, url) {
        return new URLSearchParams(url || window.location.search).get(key);
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/utils/url.js
 **/